var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "phone-number-container" },
    [
      _c(
        "el-button",
        {
          directives: [
            {
              name: "track",
              rawName: "v-track:102.click",
              value: _vm.call,
              expression: "call",
              arg: "102",
              modifiers: { click: true }
            }
          ],
          staticClass: "btn-secondary phone-number",
          attrs: { icon: "el-icon-phone" },
          on: { click: _vm.handleNumberClick }
        },
        [
          _c(
            "span",
            { staticClass: "btn-text", staticStyle: { "font-size": "20px" } },
            [_vm._v(_vm._s(_vm.displayedNumber))]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8a92198c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a92198c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/numberReveal.vue
// module id = null
// module chunks = 